import type { Dispatch, Ref, SetStateAction } from 'react';

import {
  FieldError,
  FieldLabel,
  Input,
  RadioGroupItem,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from 'design-system';

const UNIT_LABELS: Record<string, string> = {
  d: 'Day(s)',
  m: 'Month(s)',
  y: 'Year(s)'
};

const RelativeSelector = ({
  compareTo,
  setCompareTo,
  setComparisonType,
  compareToUnit,
  setCompareToUnit,
  radioRef
}: {
  compareTo: string;
  setCompareTo: Dispatch<SetStateAction<string>>;
  setComparisonType: Dispatch<SetStateAction<'absolute' | 'relative'>>;
  compareToUnit: string;
  setCompareToUnit: Dispatch<SetStateAction<string>>;
  radioRef?: Ref<HTMLButtonElement>;
}) => {
  const compareToError =
    !compareTo || compareTo.length < 1 || compareTo === '0' || compareTo === '00';

  return (
    <div className='grid gap-2'>
      <div className='flex items-center gap-2'>
        <RadioGroupItem
          ref={radioRef}
          id='comparison-type-relative'
          value='relative'
        />
        <FieldLabel htmlFor='comparison-type-relative'>Compare to</FieldLabel>
      </div>
      <div className='flex flex-wrap items-start gap-2 pl-6'>
        <div className='flex w-20 flex-col gap-1'>
          <FieldLabel
            className='sr-only'
            htmlFor='comparison-amount'
          >
            Comparison amount
          </FieldLabel>
          <Input
            id='comparison-amount'
            aria-invalid={compareToError}
            inputMode='numeric'
            maxLength={2}
            value={compareTo}
            onChange={event => {
              setComparisonType('relative');
              setCompareTo(event.target.value.replaceAll(/\D/g, ''));
            }}
          />
          {compareToError && <FieldError>Please enter a valid number</FieldError>}
        </div>
        <Select
          items={UNIT_LABELS}
          value={compareToUnit}
          onValueChange={value => {
            if (!value) return;
            setComparisonType('relative');
            setCompareToUnit(value);
          }}
        >
          <SelectTrigger
            aria-label='Comparison unit'
            className='w-32'
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(UNIT_LABELS).map(([value, label]) => (
              <SelectItem
                key={value}
                value={value}
              >
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <span className='self-center text-sm text-muted-foreground'>from latest</span>
      </div>
    </div>
  );
};
export default RelativeSelector;
